module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Visitors – Version 2")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter-1-2052"
    }
  }, [_vm._v("Chapter 1: 2052")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-2-lukas"
    }
  }, [_vm._v("Chapter 2: Lukas")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#chapter-3-start-again"
    }
  }, [_vm._v("Chapter 3: Start Again?")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#chapter-4-josef"
    }
  }, [_vm._v("Chapter 4: Josef")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#chapter-5-65-million-years-ago"
    }
  }, [_vm._v("Chapter 5: 65 Million Years Ago")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch010#chapter-6-chaos-2035"
    }
  }, [_vm._v("Chapter 6: Chaos (2035)")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch011#chapter-7-superheroes"
    }
  }, [_vm._v("Chapter 7: Superheroes?")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch012#chapter-8-contact-part-1"
    }
  }, [_vm._v("Chapter 8: Contact Part 1")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch013#chapter-9-contact-part-2"
    }
  }, [_vm._v("Chapter 9: Contact Part 2")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch014#chapter-10-potus-2036"
    }
  }, [_vm._v("Chapter 10: POTUS (2036)")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-11-the-holographic-chambers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: The Holographic Chambers")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-12-memory-past",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Memory Past")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-13-downtime",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Downtime")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-14-enceladus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Enceladus")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-15-the-conference-call",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: The Conference Call")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-16-real-superheroes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Real Superheroes")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-17-the-invitation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: The Invitation")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-18-the-race-around-andromeda",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: The Race Around Andromeda")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-19-aeon-kalpa-and-yuga",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Aeon, Kalpa, and Yuga")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-20-superheroes-and-chicken-nuggets",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: Superheroes and Chicken Nuggets")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#chapter-21-whats-colour-got-to-do-with-it",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: What’s Colour Got to Do with It?")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#chapter-22-dorian-potus-paris-and-cern",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: Dorian, POTUS, Paris and CERN")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#chapter-23-the-party-is-over",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23: The Party Is Over")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#chapter-24-doctor-evie-tobin-2006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24: Doctor Evie Tobin (2006)")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#chapter-25-elva-escapes-2035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25: Elva Escapes (2035)")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#chapter-26-enceladus-2035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26: Enceladus (2035)")])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#chapter-27-dog-vs-cat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27: Dog vs Cat")])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#chapter-28-the-diversion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28: The Diversion")])]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#chapter-29-the-lesson",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29: The Lesson")])]), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#chapter-30-alfie-returns-2045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30: Alfie Returns (2045)")])]), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#chapter-31-night-lights-and-engineers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31: Night Lights and Engineers")])]), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#chapter-32-brax-flax-and-the-space-cadet",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32: Brax, Flax and the Space Cadet")])]), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#chapter-33-a-new-plan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33: A New Plan")])]), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#chapter-34-the-eiffel-tower",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34: The Eiffel Tower")])]), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#chapter-35-alfie-and-the-jurassic-park",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 35: Alfie and the Jurassic Park")])]), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#chapter-36-the-champs-élysées-the-louvre",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 36: The Champs-Élysées / The Louvre")])]), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch041#chapter-37-the-debrief-enceladus-2035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 37: The Debrief – Enceladus (2035)")])]), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#chapter-38-the-holiday",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 38: The Holiday")])]), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch043#chapter-39-alfie-parties",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 39: Alfie Parties")])]), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch044#chapter-40-let-me-sleep",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 40: Let Me Sleep")])]), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch045#chapter-41-the-recovery-2025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 41: The Recovery (2025)")])]), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch046#chapter-42-up-bjorns-butt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 42: Up Bjorn’s Butt")])]), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch047#chapter-43-dorian-traitor-2025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 43: Dorian Traitor (2025)")])]), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch048#chapter-44-molly-zermatt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 44: Molly Zermatt")])]), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#chapter-45-cable-cars-and-the-matterhorn",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 45: Cable Cars and the Matterhorn")])]), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch050#chapter-46-room-service",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 46: Room Service")])]), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch051#chapter-47-a-memory-boost",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 47: A Memory Boost")])]), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch052#chapter-48-cern",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 48: CERN")])]), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch053#chapter-49-conspiracy-theory",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 49: Conspiracy Theory")])]), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch054#chapter-50-i-hate-humans",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 50: I Hate Humans")])]), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch055#chapter-51-a-call-for-help",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 51: A Call for Help")])]), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch056#chapter-52-the-rescue-2050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 52: The Rescue (2050)")])]), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch057#chapter-53-an-interspecies-summit-2045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 53: An Interspecies Summit (2045)")])]), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch058#chapter-54-dorian-in-zermatt-2045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 54: Dorian in Zermatt (2045)")])]), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch059#chapter-55-the-joys-of-motherhood-2045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 55: The Joys of Motherhood (2045)")])]), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch060#chapter-56-special-delivery-2045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 56: Special Delivery (2045)")])]), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch061#chapter-57-the-masters-2045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 57: The Masters (2045)")])]), _c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch062#chapter-58-observing-ateki",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 58: Observing Ateki")])]), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch063#chapter-59-dorian-in-longreach",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 59: Dorian in Longreach")])]), _c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch064#chapter-60-reporting-on-the-masters-2045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 60: Reporting on the Masters (2045)")])]), _c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch065#chapter-61-return-to-zermatt-2045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 61: Return to Zermatt (2045)")])]), _c('li', {
    attrs: {
      "id": "toc-li-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch066#chapter-62-a-new-hope-2045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 62: A New Hope (2045)")])]), _c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch067#chapter-63-apprehended-2045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 63: Apprehended (2045)")])]), _c('li', {
    attrs: {
      "id": "toc-li-68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch068#chapter-64-brax-and-flax-return-2045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 64: Brax and Flax Return (2045)")])]), _c('li', {
    attrs: {
      "id": "toc-li-69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch069#chapter-65-dire-consequences-2045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 65: Dire Consequences? (2045)")])]), _c('li', {
    attrs: {
      "id": "toc-li-70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch070#chapter-66-zermatt-again-2052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 66: Zermatt Again (2052)")])]), _c('li', {
    attrs: {
      "id": "toc-li-71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch071#chapter-67-farmer-or-aeonite-engineer-2052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 67: Farmer or Aeonite Engineer? (2052)")])]), _c('li', {
    attrs: {
      "id": "toc-li-72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch072#chapter-68-the-longreach-facility-2052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 68: The Longreach Facility (2052)")])]), _c('li', {
    attrs: {
      "id": "toc-li-73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch073#chapter-69-religion-times-up-2052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 69: Religion, Time’s Up! (2052)")])]), _c('li', {
    attrs: {
      "id": "toc-li-74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch074#chapter-70-a-huge-burp-2052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 70: A Huge Burp (2052)")])]), _c('li', {
    attrs: {
      "id": "toc-li-75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch075#chapter-71-home-2035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 71: Home (2035)")])]), _c('li', {
    attrs: {
      "id": "toc-li-76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch076#chapter-72-no-interference-2035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 72: No Interference (2035)")])]), _c('li', {
    attrs: {
      "id": "toc-li-77"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch077#the-misadventures-deleted-scenes",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("The Misadventures (Deleted Scenes)")])])]), _c('li', {
    attrs: {
      "id": "toc-li-78"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch078#chapter-73-fun-in-the-antarctic-2035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 73: Fun in the Antarctic (2035)")])]), _c('li', {
    attrs: {
      "id": "toc-li-79"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch079#chapter-74-drive-thru-2035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 74: Drive-Thru (2035)")])]), _c('li', {
    attrs: {
      "id": "toc-li-80"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch080#chapter-75-troublesome-cat-2035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 75: Troublesome Cat (2035)")])]), _c('li', {
    attrs: {
      "id": "toc-li-81"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch081#chapter-76-as-the-stomach-turns-2035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 76: As the Stomach Turns (2035)")])]), _c('li', {
    attrs: {
      "id": "toc-li-82"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch082#chapter-77-roswell-1947",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 77: Roswell (1947)")])]), _c('li', {
    attrs: {
      "id": "toc-li-83"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch083#chapter-78-im-neil-armstrong-2045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 78: I’m Neil Armstrong (2045)")])]), _c('li', {
    attrs: {
      "id": "toc-li-84"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch084#chapter-79-dax-and-the-24th-dynasty-700-bce",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 79: Dax and the 24"), _c('sup', [_vm._v("th")]), _vm._v(" Dynasty (700 BCE)")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0